import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.addTest || initialState;

export const selectTestCategories = createSelector(
  [selectDomain],
  (state) => state.testCategories
);

export const selectCommodityCategories = createSelector(
  [selectDomain],
  (state) => state.commodityCategories
);

export const selectcommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
